import styled from 'styled-components';

export const Wrap = styled.div`
  padding: 40px 20px;

  > div + div {
    margin-top: 16px;
  }

  > div {
    span + span {
      margin-top: 16px;
    }
  }
`;
